function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M654.44 32.88L638 0l-26.477 52.953C468.998 129.001 372 279.173 372 452a455.47 455.47 0 0 0 5.296 69.408L0 1276h1276l-218.46-436.927C1188.47 759.904 1276 616.174 1276 452c0-249.633-202.37-452-452-452-59.964 0-117.2 11.677-169.56 32.88z",
  fill: "#020715"
});

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 824,
  cy: 452,
  r: 452,
  fill: "url(#background_svg__paint0_linear)",
  opacity: 0.12
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M638 0l638 1276H0L638 0z",
  fill: "url(#background_svg__paint1_linear)",
  opacity: 0.07
});

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "background_svg__paint0_linear",
  x1: 372,
  y1: 0,
  x2: 1276,
  y2: 904,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#77BDFF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0E4EFF"
})), React.createElement("linearGradient", {
  id: "background_svg__paint1_linear",
  x1: 0,
  y1: 0,
  x2: 1276,
  y2: 1276,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#77BDFF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0E4EFF"
})));

var SvgBackground = function SvgBackground(props) {
  return React.createElement("svg", _extends({
    width: 1276,
    height: 1276,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI3NiIgaGVpZ2h0PSIxMjc2IiB2aWV3Qm94PSIwIDAgMTI3NiAxMjc2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTY1NC40NCAzMi44OEw2MzggMEw2MTEuNTIzIDUyLjk1M0M0NjguOTk4IDEyOS4wMDEgMzcyIDI3OS4xNzMgMzcyIDQ1MkMzNzIgNDc1LjYwMiAzNzMuODA5IDQ5OC43ODIgMzc3LjI5NiA1MjEuNDA4TDAgMTI3NkgxMjc2TDEwNTcuNTQgODM5LjA3M0MxMTg4LjQ3IDc1OS45MDQgMTI3NiA2MTYuMTc0IDEyNzYgNDUyQzEyNzYgMjAyLjM2NyAxMDczLjYzIDAgODI0IDBDNzY0LjAzNiAwIDcwNi44IDExLjY3NjYgNjU0LjQ0IDMyLjg4WiIgZmlsbD0iIzAyMDcxNSIvPgo8ZyBzdHlsZT0ibWl4LWJsZW5kLW1vZGU6aGFyZC1saWdodCIgb3BhY2l0eT0iMC4xMiI+CjxjaXJjbGUgY3g9IjgyNCIgY3k9IjQ1MiIgcj0iNDUyIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXIpIi8+CjwvZz4KPGcgc3R5bGU9Im1peC1ibGVuZC1tb2RlOmhhcmQtbGlnaHQiIG9wYWNpdHk9IjAuMDciPgo8cGF0aCBkPSJNNjM4IDBMMTI3NiAxMjc2SDBMNjM4IDBaIiBmaWxsPSJ1cmwoI3BhaW50MV9saW5lYXIpIi8+CjwvZz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjM3MiIgeTE9IjAiIHgyPSIxMjc2IiB5Mj0iOTA0IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM3N0JERkYiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMEU0RUZGIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQxX2xpbmVhciIgeDE9IjAiIHkxPSIwIiB4Mj0iMTI3NiIgeTI9IjEyNzYiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzc3QkRGRiIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMwRTRFRkYiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgBackground as ReactComponent };